import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';
import { Queries } from 'apollo';
import useAuthContext from 'hooks/useAuthContext';

const useGetPayrollUser = () => {
  const context = useAuthContext('users:read');
  const client = useApolloClient();
  const getPayrollUser = useCallback(
    (ssn, email) =>
      client
        .query({
          query: Queries.GetAdminPayrollUser, // TODO: change the query with a new query
          variables: { ssn, email },
          context,
        })
        .then(response => response.data.getPayrollUser),
    [client, context],
  );
  return getPayrollUser;
};

export default useGetPayrollUser;
